import { render, staticRenderFns } from "./OfficeOther.vue?vue&type=template&id=297fb446&"
import script from "./OfficeOther.vue?vue&type=script&lang=ts&"
export * from "./OfficeOther.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports